import { createContext, useContext, useState, ReactNode } from "react";

const ThemeContext = createContext<ThemeProps>({
  isDark: true,
  setDark: () => {},
});

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [isDark, setDark] = useState(false);

  return (
    <ThemeContext.Provider value={{ isDark, setDark }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
